<template>
	<div class="bg-white p-6 rounded-lg shadow-md">
		<div class="flex justify-between items-start mb-4">
			<div>
				<h4 class="text-[10px] font-semibold text-gray-800">{{ title }}</h4>
				<p v-if="subtitle" class="text-sm text-gray-500">{{ subtitle }}</p>
			</div>
			<!-- <div v-if="hasDocs" class="flex gap-4 text-sm">
				<button class="px-3 py-1 border border-gray-300 rounded text-gray-600 hover:bg-gray-50">CSV</button>
				<button class="px-3 py-1 border border-gray-300 rounded text-gray-600 hover:bg-gray-50">PDF</button>
			</div> -->
		</div>
		<slot></slot>
	</div>
</template>

<script setup>
defineProps({
	title: String,
	subtitle: String,
	hasDocs: {
		type: Boolean,
		default: false,
	},
});
</script>